type Props = {
  id?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  'aria-label': string
  size?: 'lg' | 'md'
}

export function MoneyInput({
  id,
  value,
  onChange,
  placeholder = '0.00',
  'aria-label': ariaLabel,
  size = 'md',
}: Props) {
  const textSize = size === 'lg' ? 'text-2xl' : 'text-xl'

  return (
    <div className="money-field">
      <span className={`money-field__prefix ${textSize}`} aria-hidden>
        $
      </span>
      <input
        id={id}
        className={`money-field__input ${textSize}`}
        inputMode="decimal"
        autoComplete="off"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-label={ariaLabel}
      />
    </div>
  )
}
